import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { UtilService } from '../service/util.service';
import { Constants } from '../constants/constants';
import { ToastService } from '../service/toast.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.scss']
})
export class CompanyProfileComponent implements OnInit {

  domains: Array<any> = new Array();
  initialDomains: Array<any> = new Array();
  initialDomainLength: number = 0;
  domainsFromApi: Array<string> = new Array();
  isEditDomainEnabled: boolean = false;
  domainsPayload: Array<string> = new Array();
  accountDetailFromAPI: any = {};
  accountDetail: any = {
    "name": "",
    "address": {},
    "email": "",
    "phone": "",
    "logo": "",
    "isd": ""
  };
  isUpdateAccountClicked: boolean = false;
  timezone = [new Date().toTimeString().slice(9), Intl.DateTimeFormat().resolvedOptions().timeZone];

  @ViewChild('domainForm') public domainForm: NgForm;
  @ViewChild('dom') public dom: NgModel;
  @Output() updateClickedEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelUpdateClickedEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService) { }

  ngOnInit() {
    this.getDomainList();
    this.getAccountDetail();
    // this.initDomains();
  }

  initAccountDetail() {
    if (this.accountDetailFromAPI != null && this.accountDetailFromAPI.contactPoints != null) {
      if (this.accountDetailFromAPI.contactPoints.addresses != null && this.accountDetailFromAPI.contactPoints.addresses.length > 0) {
        this.accountDetail.address = this.accountDetailFromAPI.contactPoints.addresses[0];
      }
      if (this.accountDetailFromAPI.contactPoints.emails != null && this.accountDetailFromAPI.contactPoints.emails.length > 0) {
        this.accountDetail.email = this.accountDetailFromAPI.contactPoints.emails[0].value;
      }
      if (this.accountDetailFromAPI.contactPoints.phones != null && this.accountDetailFromAPI.contactPoints.phones.length > 0) {
        this.accountDetail.phone = this.accountDetailFromAPI.contactPoints.phones[0].value;
        this.accountDetail.isd = this.accountDetailFromAPI.contactPoints.phones[0].isd;
      }
    }
    this.accountDetail.name = this.accountDetailFromAPI.name;
    this.accountDetail.logo = this.accountDetailFromAPI.logo;
  }

  getAccountDetail() {
    this.accountDetailFromAPI = this.apiService.accountDetail;
    this.initAccountDetail();
  }

  initDomainsForUI() {
    this.domains = new Array();
    this.domainsFromApi.forEach(element => {
      this.domains.push({ "name": element });
    });
    this.initialDomainLength = this.domains.length;
    this.initialDomains = JSON.parse(JSON.stringify(this.domains));
  }

  getDomainList() {
    this.utilService.showSpinner();
    this.apiService.getAccountDomainList().then((data) => {
      this.utilService.hideSpinner();
      this.domainsFromApi = data;
      console.log("Get Domains from API::", this.domains);
      this.initDomainsForUI();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getDomainList();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  saveDomain() {
    this.utilService.showSpinner();
    this.apiService.saveAccountDomainList(this.domainsPayload).then((data) => {
      this.utilService.hideSpinner();
      this.getDomainList();
      this.resetDomainForm();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.saveDomain();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  enableEditingDomain() {
    this.isEditDomainEnabled = !this.isEditDomainEnabled;

    if(!this.isEditDomainEnabled) {
      this.setDomainsToDefault();
    }
  }

  setDomainsToDefault() {
    this.domains = JSON.parse(JSON.stringify(this.initialDomains));
  }

  addDomain() {
    var domain: any = {
      "name": null
    }
    var domains = JSON.parse(JSON.stringify(this.domains));
    domains.push(domain);
    this.domains = domains;
    this.scroll(this.domains.length - 1);
  }

  removeDomain(index: number) {
    if (this.domains.length > 1) {
      this.domains.splice(index, 1);
      if (this.isDomainListUpdated()) {
        this.domainForm.getControl(this.dom).markAsDirty();
      } else {
        this.domainForm.form.markAsPristine();
      }
    }
  }


  isDomainListUpdated() {
    if (this.initialDomainLength != this.domains.length) {
      return true;
    }

    for (var i = 0; i < this.initialDomains.length; i++) {

      var found = false;
      for (var j = 0; j < this.domains.length; j++) {
        if (this.initialDomains[i].name == this.domains[j].name) {
          found = true;
          continue;
        }
      }
      if (!found) {
        return true;
      }
    }
    return false;
  }

  updateDomains() {
    console.log("Domains to update::", this.domains);
    this.domainsPayload = [];
    this.domains.forEach(element => {
      this.domainsPayload.push(element.name);
    });
    console.log("Payload to save::", this.domainsPayload);
    this.saveDomain();
  }

  resetDomainForm() {
    this.isEditDomainEnabled = false;
    this.isUpdateAccountClicked = false;
    this.initDomainsForUI();
  }

  scroll(id: any) {
    setTimeout(() => {
      let el = document.getElementById("domain" + id);
      el.scrollIntoView();
    }, 50);
  }

  openUpdateAccount() {
    console.log("Update clicked");
    // document.getElementById("updateAccountInfo").click();
    this.isUpdateAccountClicked = true;
    this.updateClickedEmitter.emit();

  }

  updateAccountData() {
    this.getAccountDetail();
    this.cancelUpdateAccount();
  }

  cancelUpdateAccount() {
    this.isUpdateAccountClicked = false;
    this.cancelUpdateClickedEmitter.emit();
  }

}